import { BaseService } from './../../../core/services/base.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelperService } from 'src/app/core/services/helper.service';
import { NotificationService } from '@optsolservices/ngx-notification';
import { Base64File } from 'src/app/generic/dynamic-form/models/base-64-file';
import { FileInfo, FileRestrictions, FileSelectComponent, RemoveEvent, SelectEvent } from '@progress/kendo-angular-upload';

@Component({
  selector: 'app-syspro-order-upload-supporting-document-dialog',
  templateUrl: './syspro-order-upload-supporting-document-dialog.component.html',
  styleUrls: ['./syspro-order-upload-supporting-document-dialog.component.scss']
})
export class SysproOrderUploadSupportingDocumentDialogComponent implements OnInit {
  supportingDocumentTypes: {
    supportingDocumentTypeId: number;
    supportingDocumentTypeCode: string;
    supportingDocumentTypeDesc: string;
  }[] = [];

  public fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".jpeg", ".png", ".bmp", ".pdf"],
    maxFileSize: 2097152
  };

  public fileAccept = "image/jpg, image/jpeg, image/png, image/bmp, application/pdf"

  form: FormGroup;

  selectedDupportingDocumentTypeId: number;

  files: Base64File[] = [];

  constructor(
    private dialogRef: MatDialogRef<SysproOrderUploadSupportingDocumentDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private helperService: HelperService,
    private notificationService: NotificationService,
  ) {
    this.form = fb.group({
      salesOrderNumber: [null, Validators.compose([Validators.required])],
      supportingDocumentTypeId: [null, Validators.compose([Validators.required])],
      supportingDocuments: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.form.patchValue(this.data);

    this.baseService.executeCommand<any>('portal_sales_order_upload_supporting_document_dialog_config', this.data)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.supportingDocumentTypes = response.data.supportingDocumentTypes;
        }
        else {
          this.supportingDocumentTypes = [];
        }
      });
  }

  async filesSelected(event: SelectEvent) {
    const newFiles = await this.tobase64Handler(event.files);
    this.files.push(...newFiles);
    this.updateSupportingDocumentsFormControl();
  }

  fileRemoved(event: RemoveEvent) {
    event.files.forEach(f => {
      const index = this.files.findIndex(fi => fi.uid === f.uid);
      if (index >= 0) {
        this.files.splice(index, 1);
      }
    });
    this.updateSupportingDocumentsFormControl();
  }

  save() {
    let body = this.form.getRawValue();
    console.log('body: ', body);

    this.baseService.executeCommand<any>('portal_sales_order_upload_supporting_document', body)
      .subscribe(response => {
        if (response.responseCode === 0) {
          this.dialogRef.close();
        }
      });
  }

  updateSupportingDocumentsFormControl() {
    const formControl = this.form.controls['supportingDocuments'];
    formControl.valid
    formControl.setValue(this.files);
    formControl.updateValueAndValidity();
  }

  toBase64(file: FileInfo): Promise<Base64File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.rawFile);
      reader.onload = () => resolve({
        extension: file.extension,
        name: file.name,
        size: file.size,
        uid: file.uid,
        base64: (reader.result as string).split(',')[1],
        validationErrors: file.validationErrors || []
      });
      reader.onerror = error => reject(error);
    });
  };

  async tobase64Handler(files: FileInfo[]) {
    const filePathsPromises: Promise<Base64File>[] = [];
    files.forEach(file => {
      filePathsPromises.push(this.toBase64(file));
    });

    return await Promise.all(filePathsPromises);
  }

}
